module.exports = __webpack_public_path__ + "static/img/00052B_1_C_20210214_LC.9533f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00052B_1_C_20210214_LC.png
// module id = /0xn
// module chunks = 0